// Components
import DataSmartTable from "@Layouts/components/Tables/DataSmartTable";
import NoRowsOverlay from "@Layouts/components/Tables/DataSmartTable/additional/NoRowsOverlay";

// MUI
import { useGridApiRef } from "@mui/x-data-grid-premium";

export default function OemRegionStore(props) {
	const apiRef = useGridApiRef();

	return (
		<DataSmartTable
			apiRef={apiRef}
			columns={props.columns || []}
			rows={props.data || []}
			headerHeight={28}
			rowHeight={25}
			enableCustomScrollbars
			hideFooter
			disableColumnMenu
			disableRowSelectionOnClick
			disableMultipleRowSelection
			checkboxSelection={false}
			columnVisibilityModel={{
				_id: false,
				referenceType: false,
			}}
			slots={{
				noRowsOverlay: NoRowsOverlay,
			}}
			slotProps={{
				noRowsOverlay: {
					title: "No Store Metrics data",
				},
			}}
			customProps={{
				tableContainerStyle: { height: "100%", width: "100%" },
				tableClassName: {
					"functional-table first-marked-column": true,
					"!z-[1]": true,
				},
				hide: false,
			}}
		/>
	);
}
